import { collectOrgIdsForAnyOrgPermission, requireAnyOrgPermission, requireAnySystemPermission, } from '@juvare/contact-management/backend/features/permissions/shared';
import { isAccountMemberOfOrganization } from '../../person-credentials/utils/inAccountMemberOfOrganization';
export const hasSystemPermissionOrSelf = (userState, personId, ...permissions) => {
    const hasPermission = requireAnySystemPermission(userState, ...permissions);
    return hasPermission || (!!personId && personId === (userState === null || userState === void 0 ? void 0 : userState.id));
};
export const allowViewAccountTrainCourseList = (userState, ...orgParams) => {
    return requireAnySystemPermission(userState, 'manage-accounts') || allowManageAccountByOrgPermission(userState, ...orgParams);
};
export const allowRequestLicenseCheck = (userState) => {
    const hasLicenseCheckRequestPermission = requireAnySystemPermission(userState, 'request-license-check');
    if (!hasLicenseCheckRequestPermission) {
        return false;
    }
    return requireAnySystemPermission(userState, 'manage-accounts') || requireAnyOrgPermission(userState, 'manage-members');
};
export const allowViewLicenseStatus = (userState, personId) => {
    return (hasSystemPermissionOrSelf(userState, personId, 'manage-accounts') ||
        (requireAnySystemPermission(userState, 'request-license-check') && requireAnyOrgPermission(userState, 'manage-members')));
};
export const allowManageAccountByOrgPermission = (userState, orgRole, orgStatus) => {
    if (!!orgRole && !!orgStatus) {
        // organization for which the user has permissions to manage account ids
        const orgIds = collectOrgIdsForAnyOrgPermission(userState, 'manage-members');
        // Verify whether the user being updated is a member of the organization in which the user modifying the status has 'manage-members' permissions
        return isAccountMemberOfOrganization(orgRole, orgStatus, orgIds);
    }
    return false;
};
export const allowManageLicenseStatus = (userState, orgRole, orgStatus) => {
    return (requireAnySystemPermission(userState, 'manage-accounts') ||
        (requireAnySystemPermission(userState, 'request-license-check') && allowManageAccountByOrgPermission(userState, orgRole, orgStatus)));
};
export const allowViewAndManageOrgMembers = (userState) => {
    return requireAnyOrgPermission(userState, 'manage-members', 'view-and-transfer-members', 'view-and-message-members');
};
export const allowViewEcl = (userState) => {
    return requireAnySystemPermission(userState, 'manage-accounts');
};
export const allowViewDriverLicense = (userState, personId) => {
    return hasSystemPermissionOrSelf(userState, personId, 'manage-accounts');
};
export const allowManageDriverLicense = (userState, personId) => {
    return hasSystemPermissionOrSelf(userState, personId, 'manage-accounts');
};
export const allowViewSsn = (userState) => {
    return requireAnySystemPermission(userState, 'view-ssn');
};
export const allowManageSsn = (userState, personId) => {
    return hasSystemPermissionOrSelf(userState, personId, 'manage-accounts');
};
export const allowManageCredentialingClassifiers = (userState) => {
    return requireAnySystemPermission(userState, 'manage-credentialing-classifiers');
};
export const allowViewScreenings = (userState) => {
    return requireAnySystemPermission(userState, 'view-screenings');
};
